import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, Container } from 'reactstrap';

import Matching from './components/Matching';
import OneChoice from './components/OneChoice';
import SelectWord from './components/SelectWord';
import Underlined from './components/Underlined';
import Unscramble from './components/Unscramble';
import Conjugation from './components/Conjugation';
import FillInTheBlank from './components/FillInTheBlank';
import MatchingTwoColumn from './components/MatchingTwoColumn';
import FillWordInTheBlank from './components/FillWordInTheBlank';
import FillLetterInTheBlank from './components/FillLetterInTheBlank';
import SelectWordsInSentence from './components/SelectWordsInSentence';

import fakeData from './fakeData';

const types = {
  Matching,
  OneChoice,
  SelectWord,
  Underlined,
  Unscramble,
  Conjugation,
  FillInTheBlank,
  MatchingTwoColumn,
  FillWordInTheBlank,
  FillLetterInTheBlank,
  SelectWordsInSentence,
};

const OlympicSGKModule = () => {
  const [dataFromApi, setDataFromApi] = React.useState([]);
  const [data, setData] = React.useState(null);
  const [userDataList, setUserDataList] = React.useState([]);
  // State chỉ dùng để hiển thị màu của button được chọn
  const [selectedButton, setSelectedButton] = React.useState(-1);

  const onSubmit = React.useCallback(
    (answers) => {
      const data = userDataList.filter((x) => x.id !== answers.id);
      data.push(answers);
      setUserDataList(data);

      // Lưu đáp án người dùng lên server
      localStorage.setItem('OLYMPIC_SGK_USER_DATA', JSON.stringify(data));

      // Bài tiếp theo
      const currentIndex = dataFromApi.findIndex((x) => x.id === answers.id);
      if (currentIndex === dataFromApi.length - 1) {
        return;
      }
      const nextQuestion = dataFromApi[currentIndex + 1];
      setData(nextQuestion);
      setSelectedButton(currentIndex + 1);
    },
    [dataFromApi, userDataList],
  );

  React.useEffect(() => {
    // Kết quả bài làm cũ
    const storageData = JSON.parse(localStorage.getItem('OLYMPIC_SGK_USER_DATA'));
    setUserDataList(storageData ?? []);

    // Đề
    const cachedData = JSON.parse(localStorage.getItem('OLYMPIC_SGK_DATA'));
    if (cachedData && fakeData === cachedData) {
      setDataFromApi(cachedData);
    } else {
      // Lấy dữ liệu từ api
      setDataFromApi(fakeData);
      localStorage.setItem('OLYMPIC_SGK_DATA', JSON.stringify(fakeData));
    }
  }, []);

  const QuestionComponent = types[data?.type];
  const userData = data && userDataList.find((x) => x.id === data.id)?.answers;

  // Hàm chỉ dùng để hiển thị màu của button được chọn
  const onSelectedButton = (index) => {
    setSelectedButton(index);
  };

  return (
    <React.Fragment>
      <Container>
        <Card>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook1' style={{ margin: 10, fontSize: 20 }}>
                Lớp 1
              </Link>
            </div>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook2' style={{ margin: 10, fontSize: 20 }}>
                Lớp 2
              </Link>
            </div>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook3' style={{ margin: 10, fontSize: 20 }}>
                Lớp 3
              </Link>
            </div>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook4' style={{ margin: 10, fontSize: 20 }}>
                Lớp 4
              </Link>
            </div>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook5' style={{ margin: 10, fontSize: 20 }}>
                Lớp 5
              </Link>
            </div>
            <div style={{ width: 150, height: 50 }}>
              <Link to='/olympicsgkBook8' style={{ margin: 10, fontSize: 20 }}>
                Lớp 8
              </Link>
            </div>
          </div>
        </Card>
        <Card>
          <CardBody className='d-flex flex-wrap'>
            {dataFromApi.map((item, index) => {
              return (
                <Button
                  key={index}
                  onClick={() => {
                    setData(item);
                    onSelectedButton(index);
                  }}
                  style={{ backgroundColor: selectedButton === index ? '#2dce89' : '', margin: 4 }}
                >
                  Câu thứ: {index + 1}
                </Button>
              );
            })}
          </CardBody>
        </Card>
        {data && <QuestionComponent data={data} onSubmit={onSubmit} userData={userData ?? []} />}
      </Container>
    </React.Fragment>
  );
};

export default OlympicSGKModule;
